import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a number as currency in Argentine Peso format.
 * @param amount The amount to format.
 * @param currency The currency code, default is 'ARS'.
 * @param minimumFractionDigits The minimum number of fraction digits, default is 2.
 * @returns The formatted currency string.
 */
export function formatCurrency(amount: number, { currency = 'ARS', minimumFractionDigits = 2 } = {}) {
  return amount.toLocaleString('es-ar', {
    style: 'currency',
    currency,
    minimumFractionDigits,
  });
}

// export function currencyToNumber(entry: string) {
//   const numberString = entry.replace(/[^\d.,]/g, '').replace(',', '.');
//   return +numberString;
// }
